import Button from "components/primary/button";
import Image from "next/image";
import React from "react";
import Portal from ".";
import fileDownload from "js-file-download";

const ImageModal = ({ isDownloadable, image, toggleModal }) => {
  const handleDownload = (url) => {
    const name = url.split("/");
    try {
      fetch(url, {
        mode: "cors",
      })
        .then((response) => response.blob())
        .then((blob) => {
          fileDownload(blob, `thriveAgric-${name[name.length - 1]}`);
        });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Portal>
      <div
        className="fixed flex justify-center items-center w-full h-full z-50 top-0 left-0 cursor-pointer"
        onClick={toggleModal}
        style={{
          backgroundColor: "rgba(0,0,0,0.8)",
        }}
      >
        <div
          className="bg-[#F5FBF3] w-[95%] sm:w-[80%] md:w-[70%] lg:w-[50%] h-[700px] relative"
          onClick={(e) => e.stopPropagation()}
        >
          <Image
            src={image}
            layout="fill"
            className="object-contain w-full"
            alt="gallery image"
          />
          <div
            className="flex justify-end gap-4 p-4 absolute bottom-0 right-0 w-full"
            style={{
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
          >
            {isDownloadable && (
              <Button
                buttonText="Download"
                onClick={() => handleDownload(image)}
              />
            )}
            <Button buttonText="Close" onClick={toggleModal} />
          </div>
        </div>
      </div>
    </Portal>
  );
};
export default ImageModal;
